import { Feather } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import Popover from "components/Popover/Popover";
import { LIGHT_BLUE } from "constants/";
import React, { useState } from "react";
import { Pressable, TextStyle, View } from "react-native";

interface Props {
  label: string;
  text: string | number;
  textColor?: string;
  fontWeight?: TextStyle["fontWeight"];
  showInfo?: boolean;
  onInfoPress?: () => void;
  popoverText?: string;
}

const PriceText: React.FC<Props> = (props) => {
  const {
    label,
    text,
    textColor = "black",
    fontWeight,
    showInfo,
    onInfoPress,
    popoverText,
  } = props;
  const [popoverVisible, setPopoverVisible] = useState(false);

  return (
    <View
      style={{
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          flex: 1,
          width: "100%",
        }}
      >
        <Text
          style={{
            color: textColor,
            flex: 0.7,
            textAlign: "right",
            fontWeight,
          }}
        >
          <Pressable onPress={onInfoPress}>
            {showInfo && popoverText && (
              <Popover
                popoverText={popoverText}
                isOpen={popoverVisible}
                onClickOutside={() => setPopoverVisible(false)}
              >
                <View>
                  <Feather
                    name="info"
                    color={LIGHT_BLUE}
                    size={14}
                    style={{ marginRight: 2 }}
                    onPress={() => setPopoverVisible((visible) => !visible)}
                  />
                </View>
              </Popover>
            )}
          </Pressable>
          {label} :
        </Text>

        <Text
          style={{
            color: textColor,
            flex: 0.3,
            textAlign: "right",
            fontWeight,
          }}
        >
          {text}
        </Text>
      </View>
    </View>
  );
};

export default PriceText;
